import { loadStripe, type Stripe } from '@stripe/stripe-js'
import type { Appearance } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

const STRIPE_DEMO_PK = 'pk_test_TYooMQauvdEDq54NiTphI7jx'

export function resolveStripePublishableKey(): { key: string; isDemo: boolean } {
  const fromEnv = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  if (fromEnv && fromEnv.length > 10) return { key: fromEnv, isDemo: false }
  return { key: STRIPE_DEMO_PK, isDemo: true }
}

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    const { key } = resolveStripePublishableKey()
    stripePromise = loadStripe(key)
  }
  return stripePromise
}

export const darkOnTealAppearance: Appearance = {
  theme: 'flat',
  variables: {
    colorPrimary: '#ffffff',
    colorBackground: '#ffffff',
    colorText: '#0f3a3d',
    colorTextSecondary: '#4a6b6e',
    colorTextPlaceholder: '#94aaad',
    colorIcon: '#4a6b6e',
    colorDanger: '#fee2e2',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSizeBase: '15px',
    fontWeightNormal: '500',
    borderRadius: '10px',
    spacingUnit: '4px',
  },
  rules: {
    '.Input': {
      backgroundColor: '#ffffff',
      border: 'none',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
      padding: '12px 14px',
    },
    '.Input:focus': {
      boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.6)',
    },
    '.Label': {
      color: '#ccf3f0',
      fontWeight: '500',
      marginBottom: '6px',
    },
    '.Tab': {
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      border: 'none',
    },
    '.Tab--selected': {
      backgroundColor: '#ffffff',
    },
  },
}

export const lightAppearance: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#0d9488',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSizeBase: '15px',
    borderRadius: '10px',
  },
}
